/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RestResponse} from '../model';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';

@Injectable()
export class ReportEntityProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  addEntity(id: string): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/entity`, null, ApiHeaders.getOptions());
  }

  setEntity(eid: string, name: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/entity/${eid}?name=${name}`, null, ApiHeaders.getOptions());
  }

  saveField(eid: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/entity/${eid}/field`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  deleteEntity(id: string, eid: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/entity/${eid}`, ApiHeaders.getOptions());
  }

  clearEntity(id: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/entity`, ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'REPORT_ENTITY';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return this.saveField(id, field, value);
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return undefined;
  }
}
